import * as React from "react";
import { EnquiryContext } from "./context/EnquiryState";

export const EmbeddedFormComponent = (props) => {

	const {
		state,
		dispatch,
	} = React.useContext(EnquiryContext)

	React.useEffect(() => {
		dispatch({ type: "SET_FORM_COMPONENT", payload: "embeddedForm" })
	}, [])

	const bookTourUrl = state.model?.enquiryCentreDetailsList[0].embeddedRequestATourUrl
	const waitlistUrl = state.model?.enquiryCentreDetailsList[0].embeddedWaitlistUrl

	const bookTourFrame = <div><iframe className="w-full" style={{ minHeight: "70vh" }} src={bookTourUrl} title="Book a tour form"></iframe></div>
	const waitListFrame = <div><iframe className="w-full" style={{ minHeight: "70vh" }} src={waitlistUrl} title="Waitlist form"></iframe></div>

	return (
		<React.Fragment>
			{props.type == "Tour" && bookTourFrame}
			{props.type == "Waitlist" && waitListFrame}
		</React.Fragment>
	);

}